import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ManageProjects = () => {
  const [projects, setProjects] = useState([]);
  const [title, setTitle] = useState('');
  const [desc, setDesc] = useState('');
  const [link, setLink] = useState('');
  const [image, setImage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [editId, setEditId] = useState(null);

  const fetchProjects = async () => {
    try {
      const res = await axios.get(window.API_URL + '/projects');
      setProjects(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    const token = localStorage.getItem('portalToken') || localStorage.getItem('adminToken');
    const formData = new FormData();
    formData.append('title', title);
    formData.append('desc', desc);
    formData.append('link', link);
    if (image) formData.append('image', image);

    try {
      if (editId) {
        await axios.put(`${window.API_URL}/projects/${editId}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`
          }
        });
      } else {
        await axios.post(window.API_URL + '/projects', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`
          }
        });
      }
      fetchProjects();
      resetForm();
    } catch (err) {
      console.error(err);
      alert(`Error ${editId ? 'updating' : 'adding'} project`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setTitle('');
    setDesc('');
    setLink('');
    setImage(null);
    setEditId(null);
    const fileInput = document.getElementById('project-image-input');
    if (fileInput) fileInput.value = '';
  };

  const handleEdit = (project) => {
    setEditId(project._id);
    setTitle(project.title);
    setDesc(project.desc);
    setLink(project.link || '');
    setImage(null);
  };

  const handleDelete = async (id) => {
    const token = localStorage.getItem('portalToken') || localStorage.getItem('adminToken');
    try {
      await axios.delete(`${window.API_URL}/projects/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchProjects();
    } catch (err) {
      console.error(err);
      alert('Error deleting project');
    }
  };

  return (
    <div>
      <h1 className="text-3xl font-bold mb-8 text-gray-800">Website Portfolio</h1>
      
      {/* Add/Edit Form */}
      <div className="bg-white p-6 rounded-xl shadow-md mb-8">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-[#f06600]">
            {editId ? 'Edit Project' : 'Add New Project'}
          </h2>
          {editId && (
            <button onClick={resetForm} className="text-sm text-gray-500 hover:text-gray-700 underline">
              Cancel Edit
            </button>
          )}
        </div>
        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <input type="text" placeholder="Project Title" value={title} onChange={e => setTitle(e.target.value)} required className="border p-2 rounded" />
          <input type="text" placeholder="Project Link (Optional)" value={link} onChange={e => setLink(e.target.value)} className="border p-2 rounded" />
          <textarea placeholder="Description" value={desc} onChange={e => setDesc(e.target.value)} required className="border p-2 rounded md:col-span-2 h-24"></textarea>
          <input type="file" id="project-image-input" onChange={e => setImage(e.target.files[0])} required={!editId} className="border p-2 rounded md:col-span-2" accept="image/*" />
          <button type="submit" disabled={isSubmitting} className={`md:col-span-2 text-white py-2 rounded-lg font-bold transition ${isSubmitting ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#f06600] hover:bg-[#d05800]'}`}>
            {isSubmitting ? (editId ? 'Updating...' : 'Adding...') : (editId ? 'Update Project' : 'Add Project')}
          </button>
        </form>
      </div>

      {/* Projects List */}
      <div className="bg-white p-6 rounded-xl shadow-md">
        <h2 className="text-xl font-semibold mb-4 text-gray-700">Current Projects</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map(project => (
            <div key={project._id} className="border rounded-lg overflow-hidden flex flex-col">
              <img src={`${window.API_URL}/uploads/${project.image}`} alt={project.title} className="w-full h-48 object-cover object-top border-b-4 border-[#f06600]" />
              <div className="p-4 flex flex-col flex-1">
                <h3 className="font-bold text-xl mb-2">{project.title}</h3>
                <p className="text-gray-600 text-sm mb-4 flex-1">{project.desc}</p>
                {project.link && <a href={project.link} target="_blank" rel="noreferrer" className="text-blue-500 hover:underline mb-4 text-sm break-all">{project.link}</a>}
                <div className="flex gap-2 mt-auto">
                  <button onClick={() => handleEdit(project)} className="w-1/2 py-2 bg-blue-100 text-blue-600 font-semibold rounded hover:bg-blue-200 transition">Edit</button>
                  <button onClick={() => handleDelete(project._id)} className="w-1/2 py-2 bg-red-100 text-red-600 font-semibold rounded hover:bg-red-200 transition">Delete</button>
                </div>
              </div>
            </div>
          ))}
          {projects.length === 0 && <p className="text-gray-500 col-span-full">No projects found.</p>}
        </div>
      </div>
    </div>
  );
};

export default ManageProjects;
